<template>
  <generic-update-list
    v-bind="{ model, modelHeaders, modelFk, defaultItem, filters }"
    custom-export-url="/vouchers/export/"
  >
    <template v-slot:form="{ editedItem, error }">
      <voucher-form v-bind="{ editedItem, error, modelFk }"></voucher-form>
    </template>

    <template v-slot:item.date="{ item }">
      {{ formatDate(item.date) }}
    </template>

    <template v-slot:item.warnings="{ item }">
      <v-icon v-if="item.warnings.length > 0">
        fa fa-exclamation-triangle
      </v-icon>
    </template>

  </generic-update-list>
</template>

<script>
import models from "@/models"
import VoucherForm from "@/components/VoucherForm"

export default {
  components: { VoucherForm },
  data() {
    return {
      modelHeaders: [
        { text: "Data", value: "date" },
        { text: "Pasto", value: "meal_verbose" },
        { text: "Persona", value: "person__name" },
        { text: "Ospiti", value: "guests_total" },
        { text: "Alert", value: "warnings" },
      ],
      model: models.Voucher,
      filters: [
        { name: "person", model: models.ShowPerson, text: "person__name" },
        {
          name: "meal",
          label: "Pasto",
          values: [
            { id: 1, name: "Pranzo" },
            { id: 2, name: "Cena" },
          ],
        },
        {
          name: "date",
          label: "Data",
          type: "date",
        },
      ],
    }
  },
  computed: {
    modelFk() {
      return { show: this.$route.params.id }
    },
  },
  methods: {
    defaultItem: () => ({
      meal: "",
      date: "",
      person: "",
      cost: 0,
      guests_total: "",
    }),
    formatDate(date) {
      const parsedDate = new Date(date)
      const day = String(parsedDate.getDate()).padStart(2, '0')
      const month = String(parsedDate.getMonth() + 1).padStart(2, '0')
      const year = parsedDate.getFullYear()
      return `${day}/${month}/${year}`
    },
  },
}
</script>
